<template src="./viewRefundOrder.html">
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { axiosRequests } from '../../services/axiosinstance';
    import { editUrl, generateRefundOrderStatus, getFormatedAmount, getFormatedDate, getRefundOrderStatus, retryGetPermissions } from '../../services/helper';
    import { Routes } from '../../const';
    import { RefundOrder } from '../../models/RefundOrder';
    import { TableColum, TableRow } from '../../models/Table'

    interface ComponentModel {
        refundOrderId: number,
        refundOrder: RefundOrder | null,
        showProcessAlert: boolean,
        showCancelAlert: boolean,
        refundOrderItemsColumTemplates: TableColum[],
        refundOrderItemsTableData: TableRow[],
        isLoaded: boolean,
        isButtonDisabled: boolean,
        hasProcessPermission: boolean,
        hasCancelPermission: boolean,
    }

    export default defineComponent({
        name: 'ViewRfundOrder',
        data(): ComponentModel {
            return {
                refundOrderId: 0,
                refundOrder: null,
                showProcessAlert: false,
                showCancelAlert: false,
                refundOrderItemsColumTemplates: [
                    { title: 'refund_order.name', type: 'text', isSortable: true, template: '<div class="refund_order_item_name">%data%</div>' },
                    { title: 'refund_order.amount', type: 'text', isSortable: true, template: '<div>%data%</div>' },
                    { title: 'refund_order.vat', type: 'text', isSortable: true, template: '<div class="refund_order_item_vat">%data%</div>' },
                    { title: 'refund_order.type', type: 'text', isSortable: true, template: '<div class="refund_order_item_type">%data%</div>' },
                ],
                refundOrderItemsTableData: [],
                isLoaded: false,
                isButtonDisabled: false,
                hasProcessPermission: false,
                hasCancelPermission: false,
            }
        },
        methods: {
            getRefundOrder: async function () {
                await axiosRequests.get(editUrl(Routes.getRefundOrder, this.refundOrderId))
                    .then(
                        (data: RefundOrder) => {
                            this.refundOrder = data;
                            this.refundOrderItemsTableData = this.refundOrder.refundOrderItems.map(x => { return { id: "", data: [x.name, getFormatedAmount(x.amount) + " " + data.currencySign, x.vat ? parseInt((x.vat / 100).toString()) + "%" : this.$t('refund_order.not_applicable'), this.$t(x.serviceTypeName)] } });

                            this.isLoaded = true;
                        }
                    )
                    .catch(
                        async (err: any) => {
                            if (err.status == 401) {
                                return;
                            } else if (err.status == 500) {
                                this.$store.commit('SET_ISSHOWINTERNALSERVERERROR', true);
                            } else if (err.status == 403) {
                                this.$router.push('/forbidden');
                            } else if (err.status == 400 && err.data) {
                                this.$store.commit('SET_ADD_ERROR', err.data);
                            } else {
                                this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                            }
                        }
                    );
            },
            processRefundOrder: async function () {
                this.showProcessAlert = false;

                await this.changeRefundOrder(editUrl(Routes.processRefundOrder, this.refundOrderId));
            },
            cancelRefundOrder: async function () {
                this.showCancelAlert = false;

                await this.changeRefundOrder(editUrl(Routes.cancelRefundOrder, this.refundOrderId));
            },
            changeRefundOrder: async function (url: string) {
                this.isButtonDisabled = true;

                try {
                    await axiosRequests.post(url);

                    await this.getRefundOrder();
                }
                catch (err: any) {
                    if (err.status == 401) {
                        return;
                    } else if (err.status == 403) {
                        this.$router.push('/forbidden');
                    } else if (err.status == 400 && err.data) {
                        // Проверки бэкенда приходят как ключи i18n, отказ платёжной системы — её собственным текстом
                        this.$store.commit('SET_ADD_ERROR', typeof err.data === 'string' && err.data.startsWith('error.')
                            ? err.data
                            : `${this.$t('refund_order.provider_rejected')}: ${err.data}`);
                    } else {
                        this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                    }
                }
                finally {
                    this.isButtonDisabled = false;
                }
            },
            getFormatedAmount,
            getFormatedDate
        },
        watch: {
            '$route.params.id': {
                handler: async function (id) {
                    if (!id) return;

                    this.refundOrderId = id;

                    await this.getRefundOrder();
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            refundOrderStatus: function (): string {
                return getRefundOrderStatus(generateRefundOrderStatus(
                    this.refundOrder?.processingStatus ?? 1,
                    this.refundOrder?.refundStatus ?? 0));
            }
        },
        async beforeMount() {
            let refundOrderPermission = this.$store.getters.getRefundOrdersPermission;

            if (refundOrderPermission.length == 0) refundOrderPermission = await retryGetPermissions("refundorder");

            if (!refundOrderPermission?.includes('refund-orders/{id}/detailed')) this.$router.push('/forbidden');

            this.hasProcessPermission = refundOrderPermission?.includes('refund-orders/{id}/process');
            this.hasCancelPermission = refundOrderPermission?.includes('refund-orders/{id}/cancel');
        },
    });
</script>

<style scoped>
    .refund_order_page_wrapper {
        padding-right: 5px;
        overflow: auto;
    }

    .refund_order_wrapper {
        overflow: hidden;
        max-height: calc(100vh - 184px);
        min-height: 200px;
        display: flex;
        flex-flow: column;
    }

    .button {
        padding: 8px 12px;
        border-radius: 12px;
        background-color: #eaebec;
        border: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
    }

    .button_back {
        width: 107px;
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .back_button_img {
        margin-right: 7px;
        margin-top: 1px;
        margin-left: -10px;
    }

    .refund_order {
        font-size: 20px;
        font-weight: 600;
        line-height: 26px;
        margin: 0px;
    }

    .refund_order_data {
        display: flex;
        flex-flow: wrap;
    }

    .refund_order_data_block {
        width: 25%;
    }

    .block_label {
        color: black;
        margin-top: 0px;
        margin-bottom: 8px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: calc(100% - 10px);
        font-weight: bold;
    }

    .block_info {
        margin: 0px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: calc(100% - 10px);
        color: #65656F;
    }

    .refund_order_status {
        margin-top: -1px;
        margin-left: 10px;
    }

    .refund_order_title {
        display: flex;
    }

    .status_text_not_processed {
        background-color: #fff1d7;
        padding: 4px 10px;
        border-radius: 12px;
        color: orange;
    }

    .status_text_processing {
        background-color: #e1e1ff;
        padding: 4px 10px;
        border-radius: 12px;
        color: blue;
    }

    .status_text_cancelled {
        background-color: #b4b4b4;
        padding: 4px 10px;
        border-radius: 12px;
        color: black;
    }

    .status_text_refunded {
        background-color: #def8e5;
        padding: 4px 10px;
        border-radius: 12px;
        color: green;
    }

    .status_text_not_refunded {
        background-color: #ffe5e5;
        padding: 4px 10px;
        border-radius: 12px;
        color: red;
    }

    .button_wrapper {
        display: flex;
    }

    .refund_order_process_button {
        display: flex;
        padding: 7px 24px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border: none;
        border-radius: 12px;
        cursor: pointer;
        background-color: red;
        line-height: 24px;
        color: white;
        min-width: 110px;
        height: 33px;
        margin-top: 18px;
        margin-right: 12px;
    }

    .refund_order_process_button:disabled {
        opacity: 0.5;
        cursor: no-drop;
    }

    .refund_order_cancel_button {
        display: flex;
        padding: 7px 24px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border: none;
        border-radius: 12px;
        cursor: pointer;
        background-color: #e8e805;
        line-height: 24px;
        color: #2c2c09;
        min-width: 110px;
        height: 33px;
        margin-top: 18px;
        margin-right: 12px;
    }

    .refund_order_cancel_button:disabled {
        opacity: 0.5;
        cursor: no-drop;
    }

    .receipt_link_wrapper{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .receipt_link {
        color: #df2793;
        cursor: pointer;
        text-decoration: underline;
        margin-left: 12px;
        margin-top: 5px;
    }

    @media(max-width: 860px) {
        .order_data_block {
            width: 50%;
        }
    }

    @media(max-width: 650px) {
        .refund_order_data_block {
            width: 100%;
        }

        .refund_order_status {
            margin-left: 0px;
            margin-top: 4px;
            width: fit-content;
        }

        .refund_order_title {
            display: block;
        }
    }

    @media(max-width: 500px) {
        .button_wrapper {
            display: block;
        }

        .refund_order_process_button,
        .refund_order_cancel_button {
            width: 100%;
            margin-right: 0px;
        }

        .receipt_link_wrapper {
            flex-flow: column-reverse;
        }

        .receipt_link {
            margin-left: 0px;
            margin-bottom: 12px;
        }
    }

    @media(max-width: 500px) {
        :deep(.refund_order_item_name) {
            font-weight: bold;
            margin-bottom: 10px;
        }

        :deep(.refund_order_item_vat) {
            color: #a19d9d;
            font-size: 14px;
            margin-top: 10px;
        }

        :deep(.refund_order_item_type) {
            background-color: #f5f5f5;
            padding: 1px 7px;
            border-radius: 12px;
            color: black;
            margin-top: 10px;
            font-size: 11px;
            letter-spacing: 1px;
            display: flex;
        }
    }
</style>